import { useEffect } from "react";
import { Route, Routes, useNavigate } from "react-router-dom";
import jwt_decode from "jwt-decode";
import store from "../../core/store/configureStore";
import setAuthToken from "../../core/services/setAuthToken";
import {
  loginWithMicrosoft,
  setUser,
} from "../../core/actionCreators/authActionCreators";
import { useSelector } from "react-redux";

import LayoutListPage from "../pages/LayoutListPage/LayoutListPage";
import LayoutPage from "../pages/LayoutPage/LayoutPage";
import EditLayoutPage from "../pages/EditLayoutPage/EditLayoutPage";
import SearchComponent from "../pages/ComponentList/ComponentList";
import ComponentPage from "../pages/ComponentPage/ComponentPage";
import CampaignListPage from "../pages/CampaignList/CampaignListPage";
import Campaign from "../pages/Campaign/Campaign";

import QuestionAnswer from "../pages/QuestionAnswerpage/QuestionAnswer";
import ProductTagging from "../pages/ProductTags/ProductTagging";
import CreateTagingPage from "../pages/CreateTagingPage/CreateTagingPage";

import { MODULES, CRM_SUBMODULES, hasCrmSubAccess } from "../../utils/constants";
import WhatsappCampaign from "../pages/WhatsappCampaign/WhatsappCampaign";
import AiPowered from "../pages/AiPowered/AiPowered";

import BlockCustomer from "../pages/BlockCustomer/BlockCustomer";
import Serviceability from "../pages/Serviceability/Serviceability";
import PartPayment from "../pages/PartPayment/PartPayment";
import BrandBlocks from "../pages/Blocks/Brand/BrandBlocks";
import BrandBlock from "../pages/Blocks/Brand/BrandBlock";
import Fbts from "../pages/FBT/Fbts";
import Fbt from "../pages/FBT/Fbt";
import CategoryBlocks from "../pages/Blocks/Category/CategoryBlocks";
import Faqs from "../pages/FAQ/Faqs";
import Faq from "../pages/FAQ/Faq";
import CategoryBlock from "../pages/Blocks/Category/CategoryBlock";
import StaticHtmls from "../pages/Blocks/StaticHtml/StaticHtmls";
import StaticHtml from "../pages/Blocks/StaticHtml/StaticHtml";
import Images from "../pages/Blocks/Image/Images";
import Image from "../pages/Blocks/Image/Image";
import ProductBlocks from "../pages/Blocks/Product/ProductBlocks";
import LayoutTypes from "../pages/Blocks/LayoutType/LayoutTypes";
import LayoutType from "../pages/Blocks/LayoutType/LayoutType";
import Generals from "../pages/Blocks/General/GeneralBlocks";
import General from "../pages/Blocks/General/GeneralBlock";
import LayoutBlocks from "../pages/Blocks/LayoutBlock/LayoutBlocks";
import LayoutBlock from "../pages/Blocks/LayoutBlock/LayoutBlock";
import ProductBlock from "../pages/Blocks/Product/ProductBlock";
import PlaFeeds from "../pages/PlaFeed/PlaFeeds";
import PlaFeed from "../pages/PlaFeed/PlaFeed";
import CacheDelete from "../pages/CacheDelete/CacheDelete";
import PageMappings from "../pages/PageMapping/PageMappings";
import PageMaping from "../pages/PageMapping/PageMaping";
import AttributeListings from "../pages/AttributeListing/AttributeListings";
import AttributeListing from "../pages/AttributeListing/AttributeListing";
import UserManagement from "../pages/UserManagement/UserManagement";
import WarrantyServiceApp from "../pages/WarrantyServiceApp/WarrantyServiceApp";
import Review from "../pages/ReviewsModeration/Review";
import Reviews from "../pages/ReviewsModeration/Reviews";
import ArticleForms from "../pages/Article/Article";
import ArticleListing from "../pages/Article/Articles";
import BlockTemplates from "../pages/Blocks/Template/BlockTemplates";
import BlockTemplate from "../pages/Blocks/Template/BlockTemplate";
// import Bookings from "../pages/MExpress/Bookings";
// import Booking from "../pages/MExpress/Booking";
import LeadGen from "../pages/Blocks/LandingPage/LandingPage";
import LandingPages from "../pages/Blocks/LandingPage/LandingPages";
import UrlShortener from "../pages/UrlShortener/UrlShortener";
import PromoCodeList from "../pages/PromoCodeListPage/PromoCodeList";
import PromoCodeCreateForm from "../pages/PromoCodeListPage/PromoCodeCreateForm";
import FileUploader from "../pages/FileUploader/FileUploader";
import ProductNddSupplier from "../components/ProductNddSupplier/ProductNddSupplier";
import OrderChatbotAnalytics from "../pages/OrderChatbotAnalytics/OrderChatbotAnalytics";
import PaymentModeManagement from "../pages/PaymentModeManagement/PaymentModeManagement";
import PromptManagement from "../pages/PromptManagement/PromptManagement";
import WhatsAppChatHistoryDashboard from "../pages/WhatsAppChatHistoryDashboard";
import WhatsAppDetailedAnalytics from "../pages/WhatsAppDetailedAnalytics";
import ProductChatbotAnalysis from "../pages/ProductChatbotAnalysis";
import OtpAnalyticsDashboard from "../pages/OtpAnalytics/OtpAnalyticsDashboard";
import StockAlert from "../pages/StockAlert/StockAlert";
// import UserJourneyAnalytics from "../pages/UserJourneyAnalytics";
import CustomerProfile from "../pages/Crm/CustomerProfile";
import Profile from "../pages/Profile/Profile";
import CrmDashboard from "../pages/Crm/CrmDashboard";
import OzonetelDashboard from "../pages/Crm/OzonetelDashboardVisual";
import InteractionTimeline from "../pages/Crm/InteractionTimeline";
import OzonetelCallTrack from "../pages/Crm/OzonetelCallTrack";
import OzonetelCallDetailsPage from "../pages/Crm/OzonetelCallDetailsPage";
import SaharaCallTrack from "../pages/Crm/SaharaCallTrack";
import FreshdeskTickets from "../pages/Crm/FreshdeskTickets";
import FreshdeskTicketDetails from "../pages/Crm/FreshdeskTicketDetails";
import Escalations from "../pages/Crm/Escalations";
import RfqCareSessions from "../pages/Crm/RfqCareSessions";
import AgentPerformancePage from "../pages/Crm/AgentPerformancePage";
import DeveloperToolkitTrace from "../pages/Crm/DeveloperToolkitTrace";
import GenAiCostAnalytics from "../pages/Crm/GenAiCostAnalytics";
import SamairaCallTrack from "../pages/Crm/SamairaCallTrack";
import SaharaWebRTCSimulator from "../pages/Crm/SaharaWebRTCSimulator";
import AiCallSimulator from "../pages/Crm/AiCallSimulator";
import DynamicPricingListing from "../pages/DynamicPricing/DynamicPricingListing";
import DynamicPricingFormPage from "../pages/DynamicPricing/DynamicPricingFormPage";
import ShippingPortalListing from "../pages/ShippingPortal/ShippingPortalListing";
import ShippingRuleFormPage from "../pages/ShippingPortal/ShippingRuleFormPage";



const bootstrap = () => {
  const authToken = window.localStorage.getItem("CMS_USER_AUTH_TOKEN");
  if (authToken) {
    const decoded: any = jwt_decode(authToken);
    store.dispatch(setUser(decoded));
    const currentTime = Date.now() / 1000;
    if (decoded.exp < currentTime) {
      localStorage.clear();
      window.location.href = "/";
    } else {
      setAuthToken(authToken);
      store.dispatch(loginWithMicrosoft(authToken, null));
    }
  }
};

// process.env.REACT_APP_ENVIRONMENT !== "DEVELOPMENT" && bootstrap();
bootstrap();

const ProtectedRoutes = () => {
  const authStore = useSelector((s: any) => s.authStore);
  const { user } = authStore;
  const navigate = useNavigate();

  const hasAccess = (module: string) =>
    user?.roles?.includes("Super Admin") || user?.roles?.includes(module) || process.env.REACT_APP_ENVIRONMENT === "DEVELOPMENT";

  // Per-sub-menu CRM access. CRM_ADMIN / legacy CRM / Super Admin unlock all.
  const hasCrmAccess = (submodule: string) => hasCrmSubAccess(user?.roles, submodule as any);

  useEffect(() => {
    if (
      !authStore.isAuthenticated &&
      process.env.REACT_APP_ENVIRONMENT !== "DEVELOPMENT"
    ) {
      navigate("/");
    }
  }, [authStore.isAuthenticated]);

  return (
    <>
      <Routes>
        <Route path="/profile" element={<Profile />} />

        {hasAccess(MODULES.LAYOUT) && <Route path="/layout" element={<LayoutListPage />} />}
        {hasAccess(MODULES.LAYOUT) && <Route path="/layout/:layoutId" element={<LayoutPage />} />}
        {hasAccess(MODULES.LAYOUT) && <Route path="/layout/:layoutId/edit" element={<EditLayoutPage />} />}
        {hasAccess(MODULES.LAYOUT) && <Route path="/layout/:layoutId/component" element={<SearchComponent />} />}
        {hasAccess(MODULES.LAYOUT) && <Route path="/layout/:layoutId/:componentName/:componentId" element={<ComponentPage />} />}

        {hasAccess(MODULES.ADSENSE_CAMPAIGN) && <Route path="/campaign" element={<CampaignListPage />} />}
        {hasAccess(MODULES.ADSENSE_CAMPAIGN) && <Route path="/campaign/create" element={<Campaign />} />}
        {hasAccess(MODULES.ADSENSE_CAMPAIGN) && <Route path="/campaign/:campaignId" element={<Campaign />} />}

        {hasAccess(MODULES.BLOCK_CUSTOMER) && <Route path="/blockCustomer" element={<BlockCustomer />} />}

        {hasAccess(MODULES.FBT) && <Route path="/fbt" element={<Fbts />} />}
        {hasAccess(MODULES.FBT) && <Route path="/fbt/create" element={<Fbt />} />}
        {hasAccess(MODULES.FBT) && <Route path="/fbt/:id" element={<Fbt />} />}

        {hasAccess(MODULES.FAQ) && <Route path="/faq" element={<Faqs />} />}
        {hasAccess(MODULES.FAQ) && <Route path="/faq/create" element={<Faq />} />}
        {hasAccess(MODULES.FAQ) && <Route path="/faq/:id" element={<Faq />} />}

        {hasAccess(MODULES.REVIEW) && <Route path="/review" element={<Reviews />} />}
        {hasAccess(MODULES.REVIEW) && <Route path="/review/:id" element={<Review />} />}

        {hasAccess(MODULES.WHATSAPP_CAMPAIGN) && <Route path="/whatsappCampaign" element={<WhatsappCampaign />} />}
        {hasAccess(MODULES.AI_POWERED) && <Route path="/aiPowered" element={<AiPowered />} />}

        {hasAccess(MODULES.ATTRIBUTE_LISTING) && <Route path="/attributeListing" element={<AttributeListings />} />}
        {hasAccess(MODULES.ATTRIBUTE_LISTING) && <Route path="/attributeListing/create" element={<AttributeListing />} />}
        {hasAccess(MODULES.ATTRIBUTE_LISTING) && <Route path="/attributeListing/:id" element={<AttributeListing />} />}

        {hasAccess(MODULES.QNA) && <Route path="/questionAnswer" element={<QuestionAnswer />} />}

        {hasAccess(MODULES.PRODUCT_TAGGING) && <Route path="/productTagging" element={<ProductTagging />} />}
        {hasAccess(MODULES.PRODUCT_TAGGING) && <Route path="/productTagging/create" element={<CreateTagingPage />} />}

        {hasAccess(MODULES.SERVICEABILITY) && <Route path="/serviceability" element={<Serviceability />} />}

        {hasAccess(MODULES.PART_PAYMENT) && <Route path="/part-payment" element={<PartPayment />} />}

        {hasAccess(MODULES.PLA_FEED) && <Route path="/plaFeed" element={<PlaFeeds />} />}
        {hasAccess(MODULES.PLA_FEED) && <Route path="/plaFeed/create" element={<PlaFeed />} />}
        {hasAccess(MODULES.PLA_FEED) && <Route path="/plaFeed/:id" element={<PlaFeed />} />}

        {hasAccess(MODULES.CACHE_DELETE) && <Route path="/cacheDelete" element={<CacheDelete />} />}

        {hasAccess(MODULES.USER_MANAGEMENT) && <Route path="/userManagement" element={<UserManagement />} />}

        {hasAccess(MODULES.WARRANTY_SERVICE_APP) && <Route path="/warranty-service-app" element={<WarrantyServiceApp />} />}

        {hasAccess(MODULES.PAGE_MAPPING) && <Route path="/pageMapping" element={<PageMappings />} />}
        {hasAccess(MODULES.PAGE_MAPPING) && <Route path="/pageMapping/create" element={<PageMaping />} />}
        {hasAccess(MODULES.PAGE_MAPPING) && <Route path="/pageMapping/:id" element={<PageMaping />} />}

        {hasAccess(MODULES.ARTICLE) && <Route path="/article" element={<ArticleListing />} />}
        {hasAccess(MODULES.ARTICLE) && <Route path="/article/create" element={<ArticleForms />} />}
        {hasAccess(MODULES.ARTICLE) && <Route path="/article/:id" element={<ArticleForms />} />}

        {/* MEXPRESS */}
        {/* <Route path="/mexpress" element={<Bookings />}></Route>
        <Route path="/mexpress/booking-details/:bookingId" element={<Booking />}></Route> */}

        {hasAccess(MODULES.BLOCKS) && <Route path="/blocks/lead-gen/create" element={<LeadGen />} />}
        {hasAccess(MODULES.BLOCKS) && <Route path="/blocks/lead-gen/" element={<LandingPages />} />}
        {hasAccess(MODULES.BLOCKS) && <Route path="/blocks/lead-gen/:id" element={<LeadGen />} />}

        {/* URL SHORTENER */}
        {hasAccess(MODULES.URL_SHORTENER) && <Route path="/url-shortener" element={<UrlShortener />} />}

        {/* PROMOCODE LIST */}
        {hasAccess(MODULES.PROMOCODE_LIST) && <Route path="/promocode-list" element={<PromoCodeList />} />}
        {hasAccess(MODULES.PROMOCODE_LIST) && <Route path="/promocode-list/create" element={<PromoCodeCreateForm />} />}
        {hasAccess(MODULES.PROMOCODE_LIST) && <Route path="/promocode-list/update/:promoCode" element={<PromoCodeCreateForm mode="update" />} />}

        {/* FILE UPLOADER */}
        {hasAccess(MODULES.FILE_UPLOADER) && <Route path="/file-uploader" element={<FileUploader />} />}

        {/* PRODUCT NDD SUPPLIER */}
        {hasAccess(MODULES.PRODUCT_PRICING) && <Route path="/product-pricing" element={<ProductNddSupplier />} />}

        {/* ORDER CHATBOT ANALYTICS */}
        {hasAccess(MODULES.ORDER_CHATBOT_ANALYTICS) && <Route path="/order-chatbot-analytics" element={<OrderChatbotAnalytics />} />}

        {/* PAYMENT MODE MANAGEMENT */}
        {hasAccess(MODULES.PAYMENT_MODE_MANAGEMENT) && <Route path="/payment-mode-management" element={<PaymentModeManagement />} />}

        {/* PROMPT MANAGEMENT */}
        {hasAccess(MODULES.PROMPT_MANAGEMENT) && <Route path="/prompt-management" element={<PromptManagement />} />}

        {/* WHATSAPP CHATBOT ANALYTICS */}
        {hasAccess(MODULES.WHATSAPP_CHATBOT_ANALYTICS) && <Route path="/whatsapp-chatbot-analytics" element={<WhatsAppChatHistoryDashboard />} />}
        {hasAccess(MODULES.WHATSAPP_CHATBOT_ANALYTICS) && <Route path="/whatsapp-chatbot-analytics/detailed" element={<WhatsAppDetailedAnalytics />} />}

        {/* PRODUCT CHATBOT ANALYSIS */}
        {hasAccess(MODULES.PRODUCT_CHATBOT_ANALYSIS) && <Route path="/product-chatbot-analysis" element={<ProductChatbotAnalysis />} />}

        {/* OTP ANALYTICS */}
        {hasAccess(MODULES.OTP_ANALYTICS) && <Route path="/otp-analytics" element={<OtpAnalyticsDashboard />} />}

        {/* CRM — each sub-menu is gated by its own CRM_* role (CRM_ADMIN unlocks all) */}
        {hasCrmAccess(CRM_SUBMODULES.DASHBOARD) && <Route path="/crm/dashboard" element={<CrmDashboard />} />}
        {hasCrmAccess(CRM_SUBMODULES.OZONETEL_DASHBOARD) && <Route path="/crm/ozonetel-dashboard" element={<OzonetelDashboard />} />}
        {hasCrmAccess(CRM_SUBMODULES.AGENT_PERFORMANCE) && <Route path="/crm/agent-performance" element={<AgentPerformancePage />} />}
        {hasCrmAccess(CRM_SUBMODULES.CUSTOMERS) && <Route path="/crm/search" element={<CustomerProfile />} />}
        {hasCrmAccess(CRM_SUBMODULES.CUSTOMERS) && <Route path="/crm/customer/:id" element={<CustomerProfile />} />}
        {hasCrmAccess(CRM_SUBMODULES.CUSTOMERS) && <Route path="/crm/customer/:id/timeline" element={<InteractionTimeline />} />}
        {hasCrmAccess(CRM_SUBMODULES.CALL_TRACK) && <Route path="/crm/ozonetel-call-track" element={<OzonetelCallTrack />} />}
        {hasCrmAccess(CRM_SUBMODULES.CALL_TRACK) && <Route path="/crm/ozonetel-call-track/:ucid" element={<OzonetelCallDetailsPage />} />}
        {hasCrmAccess(CRM_SUBMODULES.FRESHDESK_TICKETS) && <Route path="/crm/freshdesk-tickets" element={<FreshdeskTickets />} />}
        {hasCrmAccess(CRM_SUBMODULES.CALL_TRACK) && <Route path="/crm/sahara-voice-ai" element={<SaharaCallTrack />} />}
        {hasCrmAccess(CRM_SUBMODULES.FRESHDESK_TICKETS) && <Route path="/crm/freshdesk-tickets/:id" element={<FreshdeskTicketDetails />} />}
        {hasCrmAccess(CRM_SUBMODULES.INTERACTION_TIMELINE) && <Route path="/crm/interaction-timeline" element={<InteractionTimeline />} />}
        {hasCrmAccess(CRM_SUBMODULES.ESCALATIONS) && <Route path="/crm/escalations" element={<Escalations />} />}
        {hasCrmAccess(CRM_SUBMODULES.SAMAIRA_RFQ_CALLS) && <Route path="/crm/rfq-care" element={<RfqCareSessions />} />}
        {hasCrmAccess(CRM_SUBMODULES.SAMAIRA_RFQ_CALLS) && <Route path="/crm/samaira-rfq-calls" element={<SamairaCallTrack />} />}
        {hasCrmAccess(CRM_SUBMODULES.DEV_TOOLKIT_TRACE) && <Route path="/crm/developer-toolkit-trace" element={<DeveloperToolkitTrace />} />}
        {hasCrmAccess(CRM_SUBMODULES.AI_CALL_SIMULATOR) && <Route path="/crm/ai-call-simulator" element={<AiCallSimulator />} />}
        {hasCrmAccess(CRM_SUBMODULES.AI_CALL_SIMULATOR) && <Route path="/crm/sahara-webrtc-simulator" element={<SaharaWebRTCSimulator />} />}
        {hasAccess(MODULES.GENAI_COST_ANALYTICS) && <Route path="/genai-cost-analytics" element={<GenAiCostAnalytics />} />}
        {hasAccess(MODULES.DYNAMIC_PRICING) && <Route path="/dynamic-pricing" element={<DynamicPricingListing />} />}
        {hasAccess(MODULES.DYNAMIC_PRICING) && <Route path="/dynamic-pricing/create" element={<DynamicPricingFormPage />} />}
        {hasAccess(MODULES.DYNAMIC_PRICING) && <Route path="/dynamic-pricing/edit/:msn" element={<DynamicPricingFormPage />} />}


        {/* STOCK ALERT */}
        {hasAccess(MODULES.STOCK_ALERT) && <Route path="/stock-alert" element={<StockAlert />} />}

        {/* USER JOURNEY ANALYTICS */}
        {/* <Route path="/user-journey-analytics" element={<UserJourneyAnalytics />} /> */}

        {/* BLOCKS */}
        {hasAccess(MODULES.BLOCKS) && <Route path="/blocks/brand" element={<BrandBlocks />} />}
        {hasAccess(MODULES.BLOCKS) && <Route path="/blocks/brand/create" element={<BrandBlock />} />}
        {hasAccess(MODULES.BLOCKS) && <Route path="/blocks/brand/:id" element={<BrandBlock />} />}

        {hasAccess(MODULES.BLOCKS) && <Route path="/blocks/category" element={<CategoryBlocks />} />}
        {hasAccess(MODULES.BLOCKS) && <Route path="/blocks/category/create" element={<CategoryBlock />} />}
        {hasAccess(MODULES.BLOCKS) && <Route path="/blocks/category/:id" element={<CategoryBlock />} />}

        {hasAccess(MODULES.BLOCKS) && <Route path="/blocks/image" element={<Images />} />}
        {hasAccess(MODULES.BLOCKS) && <Route path="/blocks/image/create" element={<Image />} />}
        {hasAccess(MODULES.BLOCKS) && <Route path="/blocks/image/:id" element={<Image />} />}

        {hasAccess(MODULES.BLOCKS) && <Route path="/blocks/staticHtml" element={<StaticHtmls />} />}
        {hasAccess(MODULES.BLOCKS) && <Route path="/blocks/staticHtml/create" element={<StaticHtml />} />}
        {hasAccess(MODULES.BLOCKS) && <Route path="/blocks/staticHtml/:id" element={<StaticHtml />} />}

        {hasAccess(MODULES.BLOCKS) && <Route path="/blocks/product" element={<ProductBlocks />} />}
        {hasAccess(MODULES.BLOCKS) && <Route path="/blocks/product/create" element={<ProductBlock />} />}
        {hasAccess(MODULES.BLOCKS) && <Route path="/blocks/product/create/:id" element={<ProductBlock />} />}
        {hasAccess(MODULES.BLOCKS) && <Route path="/blocks/product/:id" element={<ProductBlock />} />}

        {hasAccess(MODULES.BLOCKS) && <Route path="/blocks/layout" element={<LayoutBlocks />} />}
        {hasAccess(MODULES.BLOCKS) && <Route path="/blocks/layout/create" element={<LayoutBlock />} />}
        {hasAccess(MODULES.BLOCKS) && <Route path="/blocks/layout/:id" element={<LayoutBlock />} />}

        {hasAccess(MODULES.BLOCKS) && <Route path="/blocks/layoutType" element={<LayoutTypes />} />}
        {hasAccess(MODULES.BLOCKS) && <Route path="/blocks/layoutType/create" element={<LayoutType />} />}
        {hasAccess(MODULES.BLOCKS) && <Route path="/blocks/layoutType/:id" element={<LayoutType />} />}

        {hasAccess(MODULES.BLOCKS) && <Route path="/blocks/template" element={<BlockTemplates />} />}
        {hasAccess(MODULES.BLOCKS) && <Route path="/blocks/template/:id" element={<BlockTemplate />} />}
        {hasAccess(MODULES.BLOCKS) && <Route path="/blocks/template/create" element={<BlockTemplate />} />}

        {hasAccess(MODULES.BLOCKS) && <Route path="/blocks/general" element={<Generals />} />}
        {hasAccess(MODULES.BLOCKS) && <Route path="/blocks/general/:id" element={<General />} />}
        {hasAccess(MODULES.BLOCKS) && <Route path="/blocks/general/create" element={<General />} />}

        {/* SHIPPING PORTAL */}
        {hasAccess(MODULES.SHIPPING_PORTAL) && <Route path="/shipping-portal" element={<ShippingPortalListing />} />}
        {hasAccess(MODULES.SHIPPING_PORTAL) && <Route path="/shipping-portal/create" element={<ShippingRuleFormPage mode="create" />} />}
        {hasAccess(MODULES.SHIPPING_PORTAL) && <Route path="/shipping-portal/update/:id" element={<ShippingRuleFormPage mode="update" />} />}
      </Routes>
    </>
  );
};

export default ProtectedRoutes;